import { prettyPrice } from '@aviata/text-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { amplitudeExperiment } from '../../../entities/amplitude';
import {
  AVIA_TOUR_PROMO_CODE,
  AVIA_TOUR_PROMO_DISCOUNT_AMOUNT,
} from '../config';
import { getAviaTourPromoDaysLeft, isAviaTourPromoWithinWindow } from '../lib';
import messages from '../locales.json';

export const useAviaTourPromo = () => {
  const { t } = useI18n({ messages });

  const { isVariant, isExperimentLoading } =
    amplitudeExperiment.lib.checkExperimentVariant(
      amplitudeExperiment.config.flags.AVIA_TOUR_PROMO,
      'avia_tour_promo_on',
    );

  const daysLeft = computed(() => getAviaTourPromoDaysLeft());

  const isVisible = computed(() => {
    if (isExperimentLoading.value) {
      return false;
    }

    return isAviaTourPromoWithinWindow() && isVariant.value;
  });

  const daysLeftText = computed(() =>
    t('avia-tour-promo.days-left', daysLeft.value),
  );

  return {
    isVisible,
    daysLeftText,
    discountAmountText: `-${prettyPrice(String(AVIA_TOUR_PROMO_DISCOUNT_AMOUNT))}`,
    promocode: AVIA_TOUR_PROMO_CODE,
  };
};
